/**
 * Render a DATE-ONLY value (a calendar day with no meaningful time-of-day)
 * that is stored as a timestamp at UTC midnight — e.g. members.move_in_date /
 * move_out_date, which the PadSplit scraper parses from a bare "YYYY-MM-DD"
 * on a UTC server.
 *
 * `new Date(v).toLocaleDateString()` renders such values in the BROWSER's
 * timezone, so every US viewer saw the previous day ("7/14" for a July 15
 * move-out — a real production bug report). Formatting with timeZone: "UTC"
 * pins the rendered day to the stored calendar date.
 *
 * Use this ONLY for date-only facts stored at UTC midnight. True event
 * timestamps (createdAt, sentAt, …) should keep local-time rendering.
 */
export function formatDateOnly(value: string | Date | null | undefined): string | null {
  if (value == null || value === "") return null;
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleDateString(undefined, { timeZone: "UTC" });
}
